<template>
	<div class="container">
		<div id="card" class="dark-bg">
			<div class="photo-wrapper">
				<div><img id="profile-photo" src="https://d1nhio0ox7pgb.cloudfront.net/_img/o_collection_png/green_dark_grey/512x512/plain/user.png"></div>
				<div><TrashIcon v-on:click.native="deleteTeamMember()" /></div>
				<div class="assignUnits" @click="openAssignUnitsToTeamMemberModal">
					<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
						viewBox="0 0 512 512" style="enable-background:new 0 0 512 512; fill: #0a2536;" xml:space="preserve">
						<g>
							<path d="M256,512c0,0,205.52-142.33,204.8-307.2C460.8,91.88,368.9,0,256,0C143.08,0,51.2,91.88,51.2,204.68
								C50.45,369.67,248.2,506.48,256,512z M153.6,179.2h76.8v-76.8h51.2v76.8h76.8v51.2h-76.8v76.8h-51.2v-76.8h-76.8V179.2z"/>
						</g>
					</svg>
				</div>
			</div>
			<div class="text-wrapper">
				<h1 :title="profileDetails.first_name+' '+profileDetails.last_name" id="name">{{profileDetails.first_name}} {{profileDetails.last_name}}</h1>
				<div class="contact-wrapper">
					<a id="phone" :href="phone"><font-awesome-icon icon="phone"/> {{profileDetails.contact_no}}</a>
					<a id="website" :href="email"><font-awesome-icon icon="envelope"/> {{profileDetails.email}}</a>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import TrashIcon from "@/components/common/TrashIcon";


export default {
	components: {
		TrashIcon
	},
	data() {
		return {
			email: 'mailto:'+this.profileDetails.email,
			phone: 'tel:'+this.profileDetails.contact_no
		}
	},
	methods: {
		async deleteTeamMember() {
			if (confirm(this.$t('deleteTeamMemberWarning'))) {
				await this.$store.dispatch('account/deleteTeamMember', this.profileDetails.id)
				this.$parent.fetchCleaner()
			}
		},
		openAssignUnitsToTeamMemberModal() {
			this.$emit('show-assign-units-checklist', this.profileDetails)
	    }
	},
	props: {
		profileDetails: {
			type: Object
		}
	}
}
</script>

<style lang="scss" scoped>

* {
	margin: 0;
	padding: 0;
}

html,
body {
	overflow: hidden;
}

td {
    padding: 0 40px;
    text-align: left;
}

h1 {
	font-weight: 800;
	width: 155px;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
	text-align: left;
}
.container {
    padding: 15px;
}

.assignUnits {
	width: 50px;
    padding: 10px;
	float: right;
    margin-top: 12px;
}

#card {
	display: flex;
	flex-direction: row-reverse;
	align-self: center;
	width: fit-content;
	background: linear-gradient(120deg, #c1cad1 20%, #ced5da 30%); 
	border-radius: 22px;
	padding: 20px 40px 20px 25px;
	margin: auto;
	box-shadow: 4px 8px 20px rgba(0, 0, 0, 0.06);
	transition: 0.3s;
	height: 150px;
	width: 350px;
}

#card:hover {
	box-shadow: none;
	cursor: pointer;
	transform: translateY(2px)
}

#card:hover > #profile-photo {
	opacity: 1
}

#profile-photo {
	height: 60px;
	width: 60px;
	margin: 0px 15px;
	border-radius: 100px;
	align-self: center;
	box-shadow: 0 6px 30px rgba(199, 199, 199, 0.5);
	opacity: 0.8;
	transition: 0.3s;
}

// .score-control {
// 	float: left;
// 	max-width: calc(100% / 3);
// 	cursor: pointer;
// 	&__header {
// 			width: calc(100% - 16px - 8px);
			
// 			div {
// 				width: calc(100% + 1px); 
// 				overflow: hidden;
// 				text-overflow: ellipsis;
// 				white-space: nowrap;
// 			}
// 	}
// }

.text-wrapper {
	font-family: 'Poppins', sans-serif;
	line-height: 0;
	align-self: center;
	margin-left: 20px;
}

.text-wrapper p {
	margin: 0;
}


.contact-wrapper a {
	display: block;
	width: 200px;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
	text-decoration: none;
	text-align: left;
	color: var(--bg);
	line-break: anywhere;
}

#name {
	font-size: 20px;
	color: #5f5f5f;
	margin-bottom: 20px;
}

#phone,
#website {
	font-size: 12px;
	color: #615F5F !important;
	margin-top: 15px;
	transition: 0.3s;
	line-height: 1.2em;
}

#phone:hover,
#website:hover {
	color: #9B9B9B !important;
}
/**  CUSTOM CHECKBOX */
input[type="checkbox"] {
  -webkit-appearance: none;
  appearance: none;
  background-color: var(--bright);
  margin: 10px;
  font: inherit;
  color: currentColor;
  width: 1.15em;
  height: 1.15em;
  border: 0.15em solid currentColor;
  border-radius: 0.15em;
  transform: translateY(-0.075em);
  padding:0px !important;
  display: grid;
  place-content: center;
}

input[type="checkbox"]::before {
  content: "";
  width: 0.65em;
  height: 0.65em;
  clip-path: polygon(14% 44%, 0 65%, 50% 100%, 100% 16%, 80% 0%, 43% 62%);
  transform: scale(0);
  transform-origin: bottom left;
  transition: 120ms transform ease-in-out;
  box-shadow: inset 1em 1em var(--primary);
  /* Windows High Contrast Mode */
  background-color: CanvasText;
}

input[type="checkbox"]:checked::before {
  transform: scale(1);
}

input[type="checkbox"]:focus {
  outline: max(2px, 0.15em) solid currentColor;
  outline-offset: max(2px, 0.15em);
}

input[type="checkbox"]:disabled {
  --primary: var(--form-control-disabled);

  color: var(--form-control-disabled);
  cursor: not-allowed;
}
/**  CUSTOM CHECKBOX */

@media screen and (max-width: 500px) and (orientation: portrait) {
	#profile-photo {
	height: 50px;
	width: 50px;
	border-radius: 50px;
	margin: 0 20px;
	}

	#card {
		padding: 30px 5px;
		// margin: auto;
		width: fit-content;
	}
	.container {
	margin: 0px;
	padding: 0px;
	}
.photo-wrapper {
	// margin-left: 20px;
}
td {
    padding: 0 5px;
	text-align: right;
}
input[type="checkbox"] {
  margin: 3px 5px 3px 1px;
}
.contact-wrapper a {
	width: 150px !important;
	}
}

@media screen and (max-width: 321px) and (orientation: portrait) {
	.text-wrapper {
    margin-left: 10px;
}
}

@media screen and (min-width: 600px)  {
h1 {
 width: 200px;
}
}

@media screen and (max-width: 780px) and (max-height: 400px) and (orientation: landscape) {
	.container {
		height: 35vh;
		margin: 0px;
	}
	#profile-photo {
		height: 50px;
		width: 50px;
		border-radius: 50px;
		margin: 0 20px;
	}
	.cardList {
    flex-direction: column;
    row-gap: 30px;
}
	// #card {
	// padding: 15px 15px;
	// 	margin: 10px auto;
	// 	width: 60%;
	// 	height: 140px;
	// }
}

</style>